
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitolonavala() {



    const cardData =
    {
        keyword: 'Mumbai to Lonavala Cab',
        heading: 'S9 Travels: Mumbai to Lonavala Cab',
        headingDescription: 'S9 Travels offers Mumbai to Lonavala Cab Service, providing a comfortable, reliable, and hassle-free journey to the scenic hill station. Whether you are planning a weekend getaway, family trip, or adventure tour, our Innova cabs ensure a smooth and enjoyable ride. With spacious interiors, luxury features, and professional drivers, we guarantee a safe and stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Lonavala cab with S9 Travels for a seamless and memorable trip!',


        top: 'Top Places to Visit in Lonavala with S9 Travels',

"topPlaces": [
    {
      "title": "Bhushi Dam",
      "description": "A favorite spot during the monsoon season, Bhushi Dam is known for its cascading water and lively atmosphere, making it perfect for picnics and family outings."
    },
    {
      "title": "Tiger's Leap",
      "description": "This cliff-top viewpoint offers breathtaking panoramic views of the lush valleys below, providing a serene escape into nature."
    },
    {
      "title": "Lion's Point",
      "description": "Famous for its stunning sunset views, Lion's Point is a must-visit for those looking to experience the magic of the Western Ghats."
    },
    {
      "title": "Rajmachi Fort",
      "description": "A historic fort and popular trekking destination, Rajmachi Fort offers a mix of adventure and history with spectacular views of the surrounding mountains."
    },
    {
      "title": "Karla Caves",
      "description": "These ancient Buddhist rock-cut caves date back to the 2nd century BC and are renowned for their intricate carvings and archaeological significance."
    },
    {
      "title": "Lohagad Fort",
      "description": "A well-known trekking spot near Lonavala, Lohagad Fort is steeped in history and rewards visitors with panoramic views from its summit."
    },
    {
      "title": "Pawna Lake",
      "description": "A picturesque reservoir ideal for camping and picnics, Pawna Lake is celebrated for its calm waters and breathtaking sunset vistas."
    },
    {
      "title": "Della Adventure Park",
      "description": "An exciting destination for thrill-seekers, Della Adventure Park offers a variety of activities including quad biking, bungee jumping, and more."
    },
    {
      "title": "Visapur Fort",
      "description": "Located adjacent to Lohagad Fort, Visapur Fort provides a challenging trek with rewarding views of the Western Ghats and the surrounding countryside."
    },
    {
      "title": "Lonavala Market",
      "description": "A vibrant local market where visitors can sample Lonavala’s famous chikki, local snacks, and shop for souvenirs, reflecting the region's culture."
    }
],

"services": [
    {
      "name": "Mumbai to Lonavala Cab Service",
      "description": "Travel comfortably from Mumbai to Lonavala with S9 Travels. Our reliable and professional taxi service ensures a smooth journey, whether you're planning a quick getaway or a long trip."
    },
    {
      "name": "Book Mumbai to Lonavala Taxi",
      "description": "Booking a taxi from Mumbai to Lonavala has never been easier. With S9 Travels, enjoy a hassle-free experience and a comfortable ride to this beautiful hill station."
    },
    {
      "name": "Affordable Mumbai to Lonavala Cab",
      "description": "Looking for an affordable taxi ride from Mumbai to Lonavala? S9 Travels offers competitive prices without compromising on comfort or service quality."
    },
    {
      "name": "Private Taxi from Mumbai to Lonavala",
      "description": "Book a private taxi from Mumbai to Lonavala with S9 Travels for a personalized and comfortable travel experience. Enjoy the scenic route with privacy and convenience."
    },
    {
      "name": "Lonavala Trip by Cab from Mumbai",
      "description": "Explore Lonavala by booking a cab from Mumbai with S9 Travels. Our comfortable and well-maintained vehicles ensure you enjoy a stress-free trip to this popular hill station."
    },
    {
      "name": "Mumbai to Lonavala One-Way or Round Trip",
      "description": "Whether you're planning a one-way trip or a round trip from Mumbai to Lonavala, S9 Travels offers flexible options to suit your travel needs, ensuring a smooth and comfortable journey."
    },
    {
      "name": "Lonavala Sightseeing by Cab",
      "description": "Book a taxi for sightseeing in Lonavala. Visit popular attractions such as the Lonavala Lake, Bhushi Dam, and Rajmachi Fort with a professional driver who knows the area well."
    },
    {
      "name": "Group Travel to Lonavala from Mumbai",
      "description": "Planning a group trip to Lonavala? S9 Travels offers spacious cabs for group travel, ensuring everyone travels comfortably together, whether it’s for a family outing or a corporate event."
    },
    {
      "name": "Luxury Taxi for Lonavala Trip",
      "description": "Travel in style and comfort with our luxury taxi service from Mumbai to Lonavala. Enjoy top-notch features, professional drivers, and an unforgettable ride."
    },
    {
      "name": "Comfortable Taxi Ride from Mumbai to Lonavala",
      "description": "Enjoy a comfortable and relaxed ride from Mumbai to Lonavala with S9 Travels. Our well-maintained vehicles and experienced drivers make sure your trip is as smooth as possible."
    },
    {
      "name": "Lonavala Vacation by Private Taxi",
      "description": "Make your Lonavala vacation unforgettable with a private taxi from Mumbai. S9 Travels offers customized travel experiences to make your trip memorable and comfortable."
    }
],

"tableData": [
  ["Mumbai to Lonavala Cab Service", "Book Mumbai to Lonavala Taxi"],
  ["Affordable Mumbai to Lonavala Cab", "Private Taxi from Mumbai to Lonavala"],
  ["Lonavala Trip by Cab from Mumbai", "Mumbai to Lonavala One-Way or Round Trip"],
  ["Lonavala Sightseeing by Cab", "Group Travel to Lonavala from Mumbai"],
  ["Luxury Taxi for Lonavala Trip", "Comfortable Taxi Ride from Mumbai to Lonavala"],
  ["Lonavala Vacation by Private Taxi", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Ride",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Lonavala cab service, perfect for a relaxing and scenic drive. Our well-maintained vehicles, including the Toyota Innova, provide ample space and air conditioning, ensuring you enjoy a smooth ride while taking in the beautiful landscapes along the way."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "We understand the importance of being on time. Our Mumbai to Lonavala cab service guarantees punctual pick-up and drop-off, so you can enjoy your trip without any delays. Whether it’s for a weekend getaway or a business trip, we make sure you reach your destination on time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions from Mumbai to Lonavala. They ensure a smooth, safe, and comfortable journey, giving you peace of mind throughout your trip. With their local knowledge, you can trust that your journey will be efficient and pleasant."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Mumbai to Lonavala cab service. We provide transparent pricing with no hidden charges. You'll receive a clear breakdown of costs when booking, allowing you to plan your trip within your budget."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Journey",
    "WhyChoosedescription": "Your safety is our priority. All our cabs are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure that you travel securely and comfortably. Whether you're traveling with family or friends, your journey will be safe and relaxing."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels is available 24/7 for your convenience. Whether you need a cab early in the morning or for a late-night return, we’re ready to provide reliable and flexible service, ensuring you can travel to and from Lonavala at your preferred time."
  },
  {
    "WhyChooseheading": "Customizable Travel Experience",
    "WhyChoosedescription": "We understand that each trip is unique. Whether you want to make additional stops along the way, explore the sights of Lonavala, or have specific requests, we offer customizable options to tailor your Mumbai to Lonavala journey to your preferences."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to Lonavala cab with S9 Travels is quick and easy. You can book online via our website or app, or contact our customer service team for personalized assistance. We ensure that the booking process is smooth and stress-free."
  }
]













    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Lonavala with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Lonavala is easy! You can book your ride via our website or mobile app, or contact our customer service team for assistance. We’ll ensure your trip is comfortable and convenient.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Lonavala travel?',
            answer: 'We offer a variety of vehicles for your journey from Mumbai to Lonavala, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best suits your needs for a smooth and enjoyable trip.',
          },
          {
            question: 'How long does the journey from Mumbai to Lonavala take?',
            answer: 'The journey from Mumbai to Lonavala typically takes around 2.5 to 3 hours, depending on traffic and road conditions. The drive is scenic, with beautiful views of the Western Ghats.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Lonavala?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Lonavala. They ensure a safe, smooth, and comfortable ride throughout the journey.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Lonavala?',
            answer: 'Yes, you can book a round-trip cab for your Mumbai to Lonavala journey. Let us know your preferred return time, and we will ensure a comfortable ride back to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Lonavala cab service?',
            answer: 'The fare for Mumbai to Lonavala cab service depends on the type of vehicle, trip duration, and specific requirements. Contact us for a customized quote and transparent pricing.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Lonavala trips?',
            answer: 'Yes, we provide pick-up services from Mumbai airport or hotels for your Lonavala trip. Our driver will ensure a seamless transfer and a comfortable start to your journey.',
          },
          {
            question: 'Can I request additional stops on the way to Lonavala?',
            answer: 'Yes, we can accommodate additional stops for meals, sightseeing, or breaks during your journey to Lonavala. Simply inform us during the booking process, and we’ll tailor the route to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Lonavala trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated upfront at the time of booking, ensuring full transparency in pricing. We make sure there are no hidden costs.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Lonavala cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and affordable cab services for your Mumbai to Lonavala trip. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a hassle-free and enjoyable experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Lonavala with S9 Travels, and the experience was amazing. The driver was professional, the car was clean and comfortable, and the journey was smooth. The scenic drive to Lonavala was beautiful. Highly recommend their services for anyone visiting Lonavala!”',
        },
        {
          name: 'Mrs. Priya Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We had a wonderful experience with S9 Travels for our trip to Lonavala. The car was spacious, clean, and comfortable, and the driver was courteous and professional. The trip was relaxing, and we enjoyed the beautiful views on the way. Would definitely use their service again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Lonavala Cab",
        "description": "Book affordable and reliable Mumbai to Lonavala cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi rides for a comfortable and scenic journey from Mumbai to Lonavala, ideal for sightseeing, vacations, and day trips.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      


    return (
        <div>
         <Helmet>
        <title>Mumbai to Lonavala Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Lonavala taxi services, including one-way, round-trip, and luxury cabs. Affordable and comfortable transport for sightseeing tours, vacations, and group travel from Mumbai to Lonavala with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitolonavala;